import { Component } from '@angular/core'
import { InlineEditDialogCellDirective } from '../inline-edit-dialog-cell'

@Component({
  selector: 'jml-lib-python-cell',
  templateUrl: './python-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class PythonCellComponent extends InlineEditDialogCellDirective {
  triggerEdit(editorType: string, readOnly: boolean) {
    this.openEditorDialog(editorType, readOnly)
  }
}
